module.exports = __webpack_public_path__ + "img/pr-8.af850e54.png";